import { useSelector } from 'react-redux'
import api from 'lib/api'

const useAPI = (urlPrefix = '') => {
    const token = useSelector(state => state.auth?.token)
    return {
        get: (url, options) => api.get(urlPrefix + url, {
            ...options,
            headers: {
                // ...options.headers,
                authorization: 'Bearer ' + token
            }
        }),
        post: (url, body, options) => api.post(urlPrefix + url, body, {
            ...options,
            headers: {
                // ...options.headers,
                authorization: 'Bearer ' + token
            }
        }),
        put: (url, body, options) => api.put(urlPrefix + url, body, {
            ...options,
            headers: {
                // ...options.headers,
                authorization: 'Bearer ' + token
            }
        }),
        patch: (url, body, options) => api.patch(urlPrefix + url, body, {
            ...options,
            headers: {
                // ...options.headers,
                authorization: 'Bearer ' + token
            }
        }),
        delete: (url, options) => api.delete(urlPrefix + url, {
            ...options,
            headers: {
                // ...options.headers,
                authorization: 'Bearer ' + token
            }
        })
    }
}

export default useAPI